/** One container for nav, content, and footer so their left edges and reading measure agree. */
export const SITE_CONTAINER = "mx-auto w-full max-w-page px-6"
